/**
 * Reorder Reminder System - Landing Page Tracking Script
 * Buy Empty Capsules
 *
 * Lightweight script for landing page visit attribution
 * Fires on /pages/reminders (education page)
 * Also handles smart redirect for logged-in customers with existing reminders
 */

// Shared configuration - safe to duplicate
window.ReminderConfig = window.ReminderConfig || {
  RAILWAY_BASE_URL: 'https://bec-orders-proxy-production.up.railway.app'
};

// Wait for DOM to be ready before running
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

function init() {
  // ==================== SMART REDIRECT FOR LOGGED-IN CUSTOMERS ====================

  // Check if customer is logged in (email in data attribute)
  const container = document.querySelector('.pre-landing-container');

  if (!container) {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  const customerEmail = container.dataset.customerEmail;

  if (customerEmail) {
    // Check if customer has an existing reminder
    fetch(`${window.ReminderConfig.RAILWAY_BASE_URL}/api/reminder/get?email=${encodeURIComponent(customerEmail)}`)
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('No reminder found');
      })
      .then(data => {
        if (data.reminder && data.reminder.reminder_date) {
          window.location.href = '/pages/reminders-setup';
          return;
        }
      })
      .catch(() => {
        // No existing reminder or API error - show landing page
      });
  }

  // ==================== ATTRIBUTION TRACKING ====================

  // Detect current source (params already declared above)
  const hasToken = params.has('cid') && params.has('token');
  const currentSource = hasToken ? 'email_link' : 'header_button';

  // Always update last visit source (for conversion attribution)
  localStorage.setItem('last_visit_source', currentSource);

  // Check if this is first visit
  const existingFirstVisit = localStorage.getItem('first_visit_source');

  if (!existingFirstVisit) {
    // FIRST VISIT - Track immediately
    localStorage.setItem('first_visit_source', currentSource);

    // Klaviyo SDK may be available but email likely not on landing page
    // first_visit_source will be captured when reminder is set on setup page
  }
}
